import type React from 'react'
import type { JSX } from 'react'
import type { ICard } from '../Card'

import { FallbackImageSizes } from 'atoms/FallbackImage'
import { IconSizes } from 'atoms/Icon'
import { COLOR } from 'vars/index'
import {
  CARDS_ASPECT_RATIO,
  CardAnimations,
  CardCorners,
  CardPosterSize,
} from '../Card.h'
import { TVCardHoverContent } from './TVCardHoverContent'
import { CardStyled } from './TVCardRounded.styled'
import { useTvCardHoverHandlers } from './useTvCardHoverHandlers'

export interface ITVCardRoundedProps extends Omit<ICard, 'children'> {
  children: React.ReactNode
}

export const TVCardRounded = ({
  children,
  posterUrl = '',
  width = '100%',
  aspectRatio = CARDS_ASPECT_RATIO.SQUARE,
  posterWidth = CardPosterSize.TvPosterRounded,
  posterHeight = CardPosterSize.TvPosterRounded,
  corners = CardCorners.CORNERS_ROUND,
  backgroundColor = COLOR.BASE_MAIN_DEFAULT,
  backgroundColorHovered = COLOR.BASE_MAIN_DEFAULT,
  childrenTransition = CardAnimations.FadeIn,
  fallbackImageSize = FallbackImageSizes.S,
  viewedButtonFavorite = true,
  fallbackImageBackground = COLOR.BASE_MAIN_DEFAULT,
  fallbackImageColor = COLOR.TEXT_ICON_SECONDARY,
  lockedSizeIcon = IconSizes.bigger,
  aclBlockedBy = false,
  ...rest
}: ITVCardRoundedProps): JSX.Element => {
  const { hoverContentVisible, cardRest, onMouseEnter, onMouseLeave } =
    useTvCardHoverHandlers(rest)

  return (
    <CardStyled
      posterUrl={posterUrl}
      width={width}
      aspectRatio={aspectRatio}
      posterWidth={posterWidth}
      posterHeight={posterHeight}
      corners={corners}
      backgroundColor={backgroundColor}
      backgroundColorHovered={backgroundColorHovered}
      childrenTransition={undefined}
      {...cardRest}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      fallbackImageSize={fallbackImageSize}
      fallbackImageColor={fallbackImageColor}
      fallbackImageBackground={fallbackImageBackground || backgroundColor}
      viewedButtonFavorite={viewedButtonFavorite}
      lockedSizeIcon={lockedSizeIcon}
      aclBlockedBy={aclBlockedBy}
    >
      <TVCardHoverContent
        favoriteChildren={children}
        hoverContent={<></>}
        viewedButtonFavorite={viewedButtonFavorite}
        aclBlockedBy={aclBlockedBy}
        childrenTransition={childrenTransition}
        hoverTrigger={hoverContentVisible}
      />
    </CardStyled>
  )
}
